export default theme => ({

  card: {
    margin: theme.spacing.unit * 2,
    width: theme.spacing.unit * 41
  },

  content: {
    padding: theme.spacing.unit * 0.5
  },

  actions: {
    padding: 0
  },

  wrapper: {
    padding: theme.spacing.unit * 4
  }

})



// WEBPACK FOOTER //
// ./src/styles/components/ProfileForm.js